<template>
  <li class="dropdown_menu" :class="mainanalyticsListCssObj">
    <a v-b-toggle.analyticsCollapse>
      <b-icon-bar-chart-line-fill></b-icon-bar-chart-line-fill>

      <span class="link-title menu_hide ml-1">ข้อมูลเชิงลึก</span>
      <span class="fa arrow menu_hide"></span>
    </a>

    <b-collapse id="analyticsCollapse" :visible="false" accordion="accordion">
      <main-analytics-collapse-menu
        :collapse-list="collapseList"
        :is-active="!isActive"
      />
    </b-collapse>
  </li>
</template>

<script>
import MainAnalyticsCollapseMenu from "@/components/layouts/sidebars/collapse-menu/MainCollapseMenu.vue";
import CompanySideBars from "../CompanySidebarSwitch";
import _ from "lodash";
import authMixin from "@/mixins/auth-mixin.js";
import { checkSubMenuAccess } from "../../../../services/accessControl";

export default {
  components: {
    MainAnalyticsCollapseMenu,
  },
  mixins: [authMixin],
  data() {
    return {
      isActive: false,
      collapseList: [],
      comId: this.$store.state.Company.companyInfo.id,
    };
  },
  computed: {
    mainanalyticsListCssObj() {
      return {
        active: this.isActive,
      };
    },
  },
  async mounted() {
    if (checkSubMenuAccess({ menu: "user-analytics" }, this.getCurrentUser())) {
      this.collapseList.push({
        title: "ภาพรวมผู้เรียน",
        to: {
          name: "analytics.user.overview",
        },
      });
    }
    if (
      checkSubMenuAccess({ menu: "course-analytics" }, this.getCurrentUser())
    ) {
      this.collapseList.push({
        title: "ภาพรวมคอร์ส",
        to: {
          name: "analytics.course.overview",
        },
      });
    }
    if (
      checkSubMenuAccess(
        { menu: "certificate-overview" },
        this.getCurrentUser()
      )
    ) {
      this.collapseList.push({
        title: "ภาพรวมประกาศนียบัตร",
        to: {
          name: "analytics.certificate.overview",
        },
      });
    }
    if (
      await checkSubMenuAccess(
        { menu: "revenue-analytics" },
        this.getCurrentUser()
      )
    ) {
      this.collapseList.push({
        title: "ภาพรวมรายได้",
        to: {
          name: "analytics.revenue.overview",
        },
      });
    }
    if (
      await checkSubMenuAccess({ menu: "tfac-overview" }, this.getCurrentUser())
    ) {
      this.collapseList.push({
        title: "สรุปภาพรวมสภาบัญชี",
        to: {
          name: "analytics.tfac.overview",
        },
      });
    }
    if (
      await checkSubMenuAccess({ menu: "nyc-overview" }, this.getCurrentUser())
    ) {
      this.collapseList.push({
        title: "สรุปภาพรวม NYC",
        to: {
          name: "analytics.tfac.overview",
        },
      });
    }
    if (
      await checkSubMenuAccess(
        { menu: "export-learning-history-report" },
        this.getCurrentUser()
      )
    ) {
      this.collapseList.push({
        title: "รายงานการเข้าเรียน",
        to: {
          name: "export.data",
        },
      });
    }
  },
  methods: {
    ...CompanySideBars,
    checkAuthorizationRoles(roles = []) {
      const companyId = this.$store.state.Company.companyInfo.id;
      const userRoles = this.$store.state.Authentication.authUser.roles
        .filter((el) => el.companyId === companyId)
        .map((el) => el.roleName);
      for (let role of roles) {
        if (userRoles.includes(role)) return true;
      }
      return false;
    },
    checkActiveRoute() {
      const useModuleMetaMatcher = !!this.$route.meta.module;
      this.isActive = _.includes(
        _.map(this.collapseList, (ech) => {
          if (!!ech.meta && !!ech.meta.module) {
            return ech.meta.module;
          }
          return ech.to.name;
        }),
        useModuleMetaMatcher ? this.$route.meta.module : this.$route.name
      );
    },
  },
};
</script>
